import { render, staticRenderFns } from "./appletsGoodEdit.vue?vue&type=template&id=24f4bc7e&"
import script from "./appletsGoodEdit.vue?vue&type=script&lang=js&"
export * from "./appletsGoodEdit.vue?vue&type=script&lang=js&"
import style0 from "./appletsGoodEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports